import React from 'react';
import Konva from 'konva';
import { Rect } from 'react-konva';
import useMiniMapViewPortPosition from 'components/canvas/components/mini-map/components/main-canvas-viewport/hooks/use-mini-map-viewport-position';
import useMiniMapOperations from 'components/canvas/components/mini-map/hooks/mini-map-operations';
import useCanvas from 'components/canvas/hooks/use-canvas';
import {
  useCanvasStageOperations,
  useCanvasStageScale,
} from 'state/canvas/stage';
import { throttle } from 'lodash';
import { color } from 'styles/settings';
import useWindowDimensions from 'components/canvas/hooks/use-window-dimensions';

export interface MainCanvasViewportProps {
  surface: string;
}

function MainCanvasViewport({ surface }: MainCanvasViewportProps) {
  const viewPortRef = React.useRef<Konva.Rect>(null);

  const { width, height } = useWindowDimensions();

  const [isDragging, setDragging] = React.useState(false);

  const [position, setPosition] = useMiniMapViewPortPosition(surface);

  const { updateCanvasStage } = useCanvasStageOperations(surface);

  const { stageInstance } = useCanvas();

  const scale = useCanvasStageScale();

  const {
    translateToCanvasPosition,
    translateCanvasPositionToMiniMapPosition,
  } = useMiniMapOperations(surface);

  function onDragEnd(event) {
    const position = translateToCanvasPosition(event.target.position());

    updateCanvasStage(position);

    setDragging(false);
  }

  React.useEffect(() => {
    stageInstance?.on('xChange yChange', function () {
      const stagePosition = stageInstance?.position();

      if (stagePosition) {
        if (isDragging === false) {
          const position = translateCanvasPositionToMiniMapPosition(
            stagePosition,
          );

          setPosition(position);
        }
      }
    });

    return () => {
      stageInstance?.off('xChange yChange');
    };
  }, []);

  React.useEffect(() => {
    setTimeout(() => {
      const stagePosition = stageInstance?.position();

      if (stagePosition) {
        const position = translateCanvasPositionToMiniMapPosition(
          stagePosition,
        );

        const animate = throttle(() => {
          viewPortRef.current?.to({
            width: width / scale,
            height: height / scale,
            ...position,
            duration: 0.3,
          });
        }, 300);

        animate();

        //setTimeout(() => setPosition(position), 100);
        setPosition(position);
      }
    }, 100);
  }, [scale]);

  return (
    <Rect
      ref={viewPortRef}
      {...position}
      width={width / scale}
      height={height / scale}
      onDragStart={() => setDragging(true)}
      onDragEnd={onDragEnd}
      stroke={color.neutral.plainBlack}
      strokeWidth={10}
      draggable
    />
  );
}

export default MainCanvasViewport;
